import { useRouteError } from 'react-router'
import { PageLayout } from '@/common/layouts/PageLayout.tsx'
import React from 'react'
import { AppLayout } from '@/common/layouts/AppLayout.tsx'
import { isNoPermissionError } from '@/common/errors/NoPermissionError.ts'
import { PageTitle } from '@/common/components/PageTitle.tsx'
import { WarningTwoTone } from '@ant-design/icons'

const getTitleAndMessage = (error: Error) => {
  const message = error?.message || String(error) || 'Unknown error'

  if (isNoPermissionError(error)) {
    return {
      title: 'Access Denied.',
      message: message,
    }
  }

  // Check for dynamic import errors (case-insensitive)
  const messageStr = String(message).toLowerCase()
  if (messageStr.includes('failed to fetch dynamically imported module') ||
    messageStr.includes('dynamically imported module') ||
    messageStr.includes('error loading dynamically imported module')) {
    return {
      title: 'Page Load Error',
      message: 'There was an issue loading a required module. This usually happens after a deployment. Please refresh the page to load the latest version.',
    }
  }

  return {
    title: 'Sorry, an unexpected error has occurred.',
    message: message && message !== 'Error' ? message : 'Please refresh the page or try again later.',
  }
}
const ErrorMain = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const error = useRouteError() as Error
  const { title, message } = getTitleAndMessage(error)

  return (
    <PageLayout className="h-full flex flex-col items-center justify-center">
      <WarningTwoTone twoToneColor="#FF4D4F" style={{ fontSize: '96px' }} />
      <h1 className="text-2xl font-bold my-4">{title}</h1>
      <p className="text-xl"><i>{message}</i></p>
    </PageLayout>
  )
}

export const ErrorPage: React.FC = () => {
  return (
    <AppLayout>
      <PageTitle value="Error" />
      <ErrorMain />
    </AppLayout>
  )
}
